import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import getResponseAndDataObject from './getResponseAndDataObject';
import { throwResponseError, throwValidationError } from './throwErrors';
var defaultOptions = {
  headers: null,
  fileParamName: 'file'
};

var uploadFile = function uploadFile(url, file) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var _defaultOptions$opts = _objectSpread({}, defaultOptions, {}, opts),
      headers = _defaultOptions$opts.headers,
      fileParamName = _defaultOptions$opts.fileParamName,
      options = _objectWithoutProperties(_defaultOptions$opts, ["headers", "fileParamName"]);

  var formData = new FormData();
  formData.append(fileParamName, file);
  return fetch(url, _objectSpread({
    method: 'POST',
    headers: _objectSpread({
      Accept: 'application/json'
    }, headers),
    body: formData
  }, options || null)).then(getResponseAndDataObject).then(throwResponseError)["catch"](throwValidationError);
};

export default uploadFile;